module.exports = __webpack_public_path__ + "img/ico063.3a5c6e50.svg";